import share from './share'

export default {
    share
}
